<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('borrowingSparePart.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('borrowingSparePart.pageTitle'),
            href: '/admin/borrowing-spare-parts'
          },
          {
            text: $t('create'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="loading">
          <div
            class="ts-border ts-border-gray-300 ts-rounded-lg ts-p-3 ts-mb-3"
          >
            <form class="form-horizontal ts-space-y-2">
              <div class="row">
                <div class="col-md-6 ts-space-y-3">
                  <Customer
                    ref="customer_control"
                    v-model="model"
                    @loading="value => (loading = value)"
                    :validate="errors"
                  />
                </div>
                <div class="col-md-6 ts-space-y-3">
                  <div class="row">
                    <label
                      class="col-md-3 form-col-label control-label required"
                      >{{ $t('borrowingSparePart.serviceDate') }}</label
                    >
                    <div class="col-md-7">
                      <a-date-picker
                        v-model="model.service_date"
                        format="DD-MM-YYYY"
                        valueFormat="DD-MM-YYYY"
                        class="ts-w-full"
                      ></a-date-picker>
                      <div class="validate" v-if="errors.has('service_date')">
                        {{ errors.first('service_date') }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="row">
                    <label
                      class="col-md-3 form-col-label control-label required"
                      >{{ $t('borrowingSparePart.serviceType') }}</label
                    >
                    <div class="col-md-7">
                      <a-select
                        v-model="model.service_type_id"
                        class="ts-w-full"
                        :options="serviceType"
                        showSearch
                        :filterOption="
                          (input, option) =>
                            option.componentOptions.children[0].text
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                        "
                      ></a-select>
                      <div
                        class="validate"
                        v-if="errors.has('service_type_id')"
                      >
                        {{ errors.first('service_type_id') }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="row">
                    <label
                      class="col-md-3 form-col-label control-label"
                      :class="{ required: isSale }"
                      >{{ $t('borrowingSparePart.plateNumber') }}</label
                    >
                    <div class="col-md-7">
                      <a-select
                        v-model="model.plate_number"
                        class="ts-w-full"
                        :options="plateNumberList"
                        showSearch
                        :filterOption="
                          (input, option) =>
                            option.componentOptions.children[0].text
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                        "
                      ></a-select>
                      <div class="validate" v-if="errors.has('plate_number')">
                        {{ errors.first('plate_number') }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 ts-space-y-3">
                  <div class="row">
                    <label
                      class="col-md-3 form-col-label control-label required"
                      >{{ $t('borrowingSparePart.requestBy') }}</label
                    >
                    <div class="col-md-7">
                      <a-select
                        v-model="model.requested_by"
                        class="ts-w-full"
                        :options="employeeList"
                        showSearch
                        :filterOption="
                          (input, option) =>
                            option.componentOptions.children[0].text
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                        "
                      ></a-select>
                      <div class="validate" v-if="errors.has('requested_by')">
                        {{ errors.first('requested_by') }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 ts-space-y-3">
                  <div class="row">
                    <label
                      class="col-md-3 form-col-label control-label"
                      :class="{ required: isSale }"
                      >{{ $t('borrowingSparePart.deliveredBy') }}</label
                    >
                    <div class="col-md-7">
                      <a-select
                        v-model="model.delivered_by"
                        class="ts-w-full"
                        :options="employeeList"
                        showSearch
                        :filterOption="
                          (input, option) =>
                            option.componentOptions.children[0].text
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                        "
                      ></a-select>
                      <div class="validate" v-if="errors.has('delivered_by')">
                        {{ errors.first('delivered_by') }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 ts-space-y-3">
                  <div class="row">
                    <label
                      class="col-md-3 form-col-label control-label"
                      :class="{ required: isSale }"
                      >{{ $t('borrowingSparePart.verifiedBy') }}</label
                    >
                    <div class="col-md-7">
                      <a-select
                        v-model="model.verified_by"
                        class="ts-w-full"
                        :options="employeeList"
                        showSearch
                        :filterOption="
                          (input, option) =>
                            option.componentOptions.children[0].text
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                        "
                      ></a-select>
                      <div class="validate" v-if="errors.has('verified_by')">
                        {{ errors.first('verified_by') }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 ts-space-y-3">
                  <div class="row">
                    <label
                      class="col-md-3 form-col-label control-label"
                      :class="{ required: isSale }"
                      >{{ $t('borrowingSparePart.receivedBy') }}</label
                    >
                    <div class="col-md-7">
                      <a-select
                        v-model="model.received_by"
                        class="ts-w-full"
                        :options="employeeList"
                        showSearch
                        :filterOption="
                          (input, option) =>
                            option.componentOptions.children[0].text
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                        "
                      ></a-select>
                      <div class="validate" v-if="errors.has('received_by')">
                        {{ errors.first('received_by') }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 ts-space-y-3">
                  <div class="row">
                    <label
                      class="col-md-3 form-col-label control-label"
                      :class="{ required: isSale }"
                      >{{ $t('borrowingSparePart.borrowingRef') }}</label
                    >
                    <div class="col-md-7">
                      <input
                        v-model.trim="model.borrowing_ref"
                        type="text"
                        class="form-control"
                      />
                      <div class="validate" v-if="errors.has('borrowing_ref')">
                        {{ errors.first('borrowing_ref') }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="ts-border ts-border-gray-300 ts-rounded-lg ts-p-3">
            <ProductDetail
              v-model="model"
              :validate="errors"
              @showSerial="onShowSerial"
              @loading="v => (loading = v)"
              ref="detail"
            />
          </div>
          <div class="row ts-mt-4">
            <div class="col-md-5">
              <textarea
                v-model="model.remarks"
                rows="1"
                class="form-control"
                placeholder="Remark"
              ></textarea>
            </div>
            <div class="col-md-7 ts-space-x-4 ts-flex ts-justify-end ts-h-8">
              <ts-button
                :disabled="loading"
                @click.prevent="$router.push({ name: 'service-request' })"
                >{{ $t('cancel') }}</ts-button
              >
              <ts-button
                :disabled="loading"
                color="primary"
                outline
                @click.prevent="onSavePreview"
                >{{ $t('savePrint') }}</ts-button
              >
              <ts-button :disabled="loading" color="primary" @click="onSave">{{
                $t('save')
              }}</ts-button>
            </div>
          </div>
        </ts-loading-banner>
      </ts-card-wrapper>
    </ts-card>
    <a-modal :title="$t('pdf')" width="50%" v-model="show_pdf" :footer="null">
      <ts-preview-pdf v-model="loading" :src="src" />
    </a-modal>
  </div>
</template>
<script>
import moment from 'moment'
import ProductDetail from './components/product-details.vue'
import Customer from './components/customer.vue'
import { mapActions, mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import { includes } from 'lodash'
export default {
  name: 'borrowingSparePart',
  components: {
    ProductDetail,
    Customer
  },
  data() {
    return {
      loading: false,
      show_pdf: false,
      src: null,
      errors: new Errors(),
      model: {
        service_date: moment().format('DD-MM-YYYY'),
        customer_id: null,
        fx_rate_kh: 0,
        remarks: null,
        engine_number: null,
        requested_by: null,
        delivered_by: null,
        received_by: null,
        verified_by: null,
        borrowing_ref: null,
        is_dealer_price: false,
        is_pdf: false,
        product_detail: [],
        product_id: undefined,
        product_name: null,
        plate_number: null,
        service_type_id: null,
        service_request_id: null
      }
    }
  },
  computed: {
    ...mapState('wholesale/borrowingSparePart', ['formModels']),
    isSale() {
      return includes([3, 4], this.$store.state.authUser.user.mobile_role_id)
    },
    employeeList() {
      return this.formModels.employee.map(el => ({
        value: el.employee_id,
        label: el.employee_name_kh + '|' + el.employee_name_en
      }))
    },
    plateNumberList() {
      return this.formModels.vehiclePlate.map(el => ({
        value: el.plate_number,
        label: el.plate_number
      }))
    },
    serviceType() {
      return this.formModels.serviceType.map(el => ({
        value: el.service_type_id,
        label: el.service_type
      }))
    }
  },
  created() {},
  methods: {
    ...mapActions('wholesale/borrowingSparePart', ['getFormViewData', 'store']),
    async init({ params, index }) {
      this.loading = true
      this.model.service_request_id = this.$route.params.service_request_id
      await this.getFormViewData({
        params: {
          service_request_id: this.model.service_request_id
        },
        index: index
      })
      this.onAddProduct()
      this.loading = false
    },
    onAddProduct() {
      this.model.customer_id = this.formModels.serviceRequest.requested_by
      this.model.product_id = this.formModels.serviceRequest.product_id
      this.model.engine_number = this.formModels.serviceRequest.imei
      this.model.plate_number = this.formModels.serviceRequest.plate_number
      this.model.borrowing_ref = this.formModels.serviceRequest.order_kads
      this.model.requested_by = this.formModels.serviceRequest.technician1_by
        ? this.formModels.serviceRequest.technician1_by.employee_id
        : null
      this.model.verified_by = this.formModels.serviceRequest.technician2_by
        ? this.formModels.serviceRequest.technician2_by.employee_id
        : null

      if (this.formModels.serviceRequest.fee_type) {
        let product = this.formModels.serviceRequest.fee_type

        let uomId = product.unit_of_measures.find(u => u.is_default).uom_id
        let price = product.sale_code.find(p => p.uom_id == uomId)
        this.model.product_detail.push({
          product_id: product.product_id,
          barcode: product.barcode,
          product_name: product.product_name_kh,
          uom_id: uomId,
          quantity_order: 1,
          sale_price: this.model.is_dealer_price
            ? price.dealer_price
            : price.sale_price,
          vendor_standard_price: price.vendor_standard_price,
          discount_rate: 0,
          amount: price.sale_price * 1,
          ending_balance: 'N/A',
          remarks: null,
          sfo_id: null,
          service_date: this.model.service_date
        })
        this.$refs.detail.tempDetails.push(product)
      }
    },
    onSave() {
      this.loading = true
      this.store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$router.push({ name: 'borrowing-spare-part' })
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onSavePreview() {
      this.loading = true
      this.show_pdf = true
      this.src = ''
      this.model.is_pdf = true
      this.store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.src = response.url
          this.clearInput()
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onShowSerial() {
      this.$refs.customer_control.show_engine = true
    },
    clearInput() {
      this.model.service_date = moment().format('DD-MM-YYYY')
      this.model.customer_id = null
      this.model.fx_rate_kh = 0
      this.model.remarks = null
      this.model.engine_number = null
      this.model.requested_by = null
      this.model.delivered_by = null
      this.model.received_by = null
      this.model.verified_by = null
      this.model.borrowing_ref = null
      this.model.is_dealer_price = false
      this.model.is_pdf = false
      this.model.product_detail = []
      this.model.product_id = undefined
      this.model.product_name = null
      this.model.plate_number = null
      this.model.service_type_id = null
      this.$refs.detail.tempDetails = []
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.init({
        index: undefined,
        params: undefined
      })
    })
  }
}
</script>
